import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import React, {
  FC,
  useCallback, useEffect, useMemo, useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/components/PersonalAccaunt/PersonalAccount.module.scss'
import { BlockBalance } from '@src/components/PersonalAccaunt/BlockBalance'
import card from '@src/images/visa.svg'
import cardMaster from '@src/images/pay_type_3.svg'
import { Line } from '@src/components/Line/Line'
import { Button } from '@src/components/Button/Button'
import { ReactComponent as ArrowDown } from '@src/assets/arrow_down.svg'
import { ReactComponent as Update } from '@src/assets/update.svg'
import { AppDispatch } from '@src/store/store'
import {
  selectUserCurrentAddresses, selectUserInfo,
  selectUserIsLoadingListAddresses, selectUserListAddresses, selectUserSalary, selectUserServices, selectUserSumToPay,
} from '@src/store/ducks/user/selectors'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { getAccounts } from '@src/store/ducks/user/thunks'
import { setCurrentAddresses } from '@src/store/ducks/user/reducer'
import {
  selectBackError, selectCreditLimitDescription,
  selectIsLoadingCreditLimit,
  selectIsSuccessCreditLimit,
  selectRecurrentCard,
} from '@src/store/ducks/pay/selectors'
import {
  addCreditLimit, getCreditLimitDescription, getRecurrentCard, setAutoPay,
} from '@src/store/ducks/pay/thunks'
import { setBackError, setIsChecked, setIsSuccessCreditLimit } from '@src/store/ducks/pay/reducer'
import useQuery from '@src/hooks/useQuery'
import { ReactComponent as Edit } from '@src/assets/interface_edit.svg'
import { setIsEditName } from '@src/store/ducks/app/reducer'
import { Modal } from '../common/Modal/Modal'
import { PaymentForm } from '../PaymentForm/PaymentForm'

type PersonalAccountProps = {
  noPay?: boolean
}

export const PersonalAccount: FC<PersonalAccountProps> = ({ noPay }) => {
  const dispatch = useDispatch<AppDispatch>()
  const listAddresses = useSelector(selectUserListAddresses)
  const currentAddresses = useSelector(selectUserCurrentAddresses)
  const isLoading = useSelector(selectUserIsLoadingListAddresses)
  const services = useSelector(selectUserServices)
  const sumToPay = useSelector(selectUserSumToPay)
  const isSuccessCreditLimit = useSelector(selectIsSuccessCreditLimit)
  const isLoadingCreditLimit = useSelector(selectIsLoadingCreditLimit)
  const backError = useSelector(selectBackError)
  const creditLimitDescription = useSelector(selectCreditLimitDescription)
  const salary = useSelector(selectUserSalary)
  const { tariff } = useSelector(selectUserServices)
  const recurrentCard = useSelector(selectRecurrentCard)
  const [openBlock, setOpenBlock] = useState(false)
  const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false)
  const [isOpenCreditLimitModal, setIsOpenCreditLimitModal] = useState(false)
  const isTv = useQuery('tv')
  const user = useSelector(selectUserInfo)

  const isAddressList = useMemo(() => listAddresses.length > 1, [listAddresses.length])
  const checked = useMemo(() => recurrentCard.status === '1', [recurrentCard.status])

  useEffect(() => {
    dispatch(getCreditLimitDescription())
  }, [dispatch])

  useEffect(() => {
    if (currentAddresses) {
      dispatch(getRecurrentCard())
    }
  }, [dispatch, currentAddresses])

  const isChecked = () => {
    dispatch(setAutoPay())
    if (recurrentCard.status === '1') {
      dispatch(setIsChecked('2'))
    } else {
      dispatch(setIsChecked('1'))
    }
  }

  const handleCloseCreditLimit = useCallback(() => {
    setIsOpenCreditLimitModal(false)
    dispatch(setIsSuccessCreditLimit(false))
    dispatch(setBackError(''))
  }, [dispatch])

  return (
    <>
      <Preloader center loading={isLoading} isOver>
        <div className={cn(style.personalAccount)}>
          {currentAddresses && services.tariff ? (
            <div>
              <div className={style.headerBlock}>
                <h3>
                  {user.isSubscriber ? (
                    <div>
                      <span>{ user.username.split(' ')[1]}</span>
                      <Edit className={style.editBtn} onClick={() => { dispatch(setIsEditName(true)) }} />
                    </div>
                  ) : 'Лицевой счет'}
                </h3>
                <div>
                  <button onClick={() => dispatch(getAccounts())} type="button" className={style.headerBlock__update}>
                    Обновить
                    <Update />
                  </button>
                </div>
              </div>
              <div className={style.personalNumber}>
                <div
                  className={cn(style.personalNumber__box, openBlock && style.active)}
                >
                  <button
                    onClick={() => setOpenBlock(!openBlock)}
                    className={cn(style.personalNumber__buttonSize, openBlock && style.active)}
                    type="button"
                    disabled={!isAddressList}
                  >
                    {user.isSubscriber ? 'Мой лицевой счет ' : '№'}
                    <span style={{ marginLeft: user.isSubscriber ? '5px' : '0' }}>{currentAddresses.account}</span>
                    {isAddressList && <ArrowDown />}
                  </button>

                  {openBlock && (
                    <div className={style.dropBlock}>
                      {listAddresses.map((el) => (
                        <button
                          key={el.accountId}
                          onClick={() => {
                            dispatch(setCurrentAddresses(el.accountId))
                            setOpenBlock(!openBlock)
                            dispatch(getAccounts())
                          }}
                          type="button"
                        >
                          №
                          {el.account}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                {!!tariff.length && (
                  <div className={style.personalNumber__description}>{tariff[0].address}</div>
                )}
              </div>
              <div className={style.balanceContainer}>
                <BlockBalance
                  title="Текущий баланс"
                  result={currentAddresses.balance}
                />
                <BlockBalance title="Ежемесячная плата" result={salary} orangeStyle />
              </div>
              <div className={style.daysForPay}>
                {/* <div>
                <span>150 дней </span>
                до следующей оплаты
              </div> */}
              </div>
              <Line />
              {recurrentCard.lastCard && !noPay && (
                <>
                  <div className={style.autopay}>
                    <div>Включить автоплатёж</div>
                    <label className={style.switch} htmlFor="autopay">
                      <input
                        checked={checked}
                        type="checkbox"
                        id="autopay"
                        name="autopay"
                        onChange={() => isChecked()}
                      />
                      <span className={cn(style.slider, style.round)} />
                    </label>
                  </div>
                  <div className={style.mobileTitle}>Платежная карта</div>
                  <div className={style.cardContainer}>
                    <div className={style.title}>Карта</div>
                    <div className={style.card}>
                      {recurrentCard.type === 'VISA'
                        ? <img src={card} alt="visa card" />
                        : <img src={cardMaster} alt="master card" />}
                      <div className={style.card_number}>
                        {recurrentCard.lastCard && `**** **** **** ${recurrentCard.lastCard.substr(10, 4)}`}
                      </div>
                    </div>
                    <span />
                    {/*  <div className={style.change}>Сменить карту</div> */}
                  </div>
                </>
              )}
              {!isTv && (
                <div className={style.payments}>
                  <NavLink to="/payments">
                    Платежи и списания
                  </NavLink>
                </div>
              )}

              {!noPay && (
                <Button
                  type="secondary"
                  className={style.btnSize}
                  outline
                  onClickFunc={() => setIsOpenPaymentModal(true)}
                >
                  Пополнить баланс
                </Button>
              )}
              {!!tariff.length && !tariff[0].active && (
                <button
                  className={style.creditLimit_btn}
                  type="button"
                  onClick={() => setIsOpenCreditLimitModal(true)}
                >
                  Доверительный платеж
                </button>
              )}
              {isTv && (
                <div className={style.payments}>
                  {/* @ts-ignore */}
                  <Button type="primary" onClickFunc={() => { window?.ReactNativeWebView?.postMessage('logout') }}>
                    Выход
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div>Не найдены адреса</div>
          )}
        </div>
      </Preloader>

      <Modal styleModalWindow={style.size} isOpen={isOpenPaymentModal} close={() => setIsOpenPaymentModal(false)}>
        <PaymentForm />
      </Modal>

      <Modal
        styleModalWindow={style.size}
        isOpen={isOpenCreditLimitModal}
        close={handleCloseCreditLimit}
      >
        {isSuccessCreditLimit && (
          <>
            <div className={style.confirmActions}>
              Ваш заявка была
              <span className="blue"> успешно оформлена!</span>
              {' '}
            </div>
            <Button className={style.btnPosition} type="primary" onClickFunc={handleCloseCreditLimit}>
              В личный кабинет
            </Button>
          </>
        )}

        {!isSuccessCreditLimit && (
          <>
            <div className={style.creditLimit_title}>Доверительный платеж</div>
            <div className={style.creditLimit_desc}>
              <div dangerouslySetInnerHTML={{ __html: creditLimitDescription }} />
              Рекомендованный платеж составляет
              {' '}
              {sumToPay}
              {' '}
              р.
            </div>
            <div className={style.creditLimitActions}>
              <Button
                loading={isLoadingCreditLimit}
                onClickFunc={() => { dispatch(addCreditLimit()) }}
              >
                Подтвердить
              </Button>
              <Button
                disabled={isLoadingCreditLimit}
                type="textSecondary"
                onClickFunc={handleCloseCreditLimit}
              >
                Отменить
              </Button>
            </div>
            <div className={style.creditLimit_error}>{backError}</div>
            <br />
            <div>
              Нажав на кнопку «Подтвердить», я соглашаюсь с условиями предоставления услуги «Доверительный платеж».
            </div>
          </>
        )}
      </Modal>
    </>
  )
}
